import React from "react";
import styles from "./DesignersEditor.module.css";

// Repeatable designer credits: each row is {name, link}. Shown on the
// product page as "Designed by A ↗, B ↗ & C ↗".
const DesignersEditor = ({ designers, onChange }) => {
  const update = (index, patch) => {
    onChange(designers.map((d, i) => (i === index ? { ...d, ...patch } : d)));
  };

  return (
    <div className={styles.wrap}>
      {designers.map((designer, index) => (
        <div className={styles.row} key={index}>
          <input
            className={styles.name}
            placeholder="Designer name (e.g. Blaque Art)"
            value={designer.name}
            onChange={(e) => update(index, { name: e.target.value })}
          />
          <input
            className={styles.link}
            placeholder="Their link (optional) — @handle or instagram.com/…"
            value={designer.link}
            onChange={(e) => update(index, { link: e.target.value })}
          />
          <button
            type="button"
            className={styles.remove}
            onClick={() => onChange(designers.filter((_, i) => i !== index))}
            aria-label="Remove designer"
          >
            ×
          </button>
        </div>
      ))}
      <button
        type="button"
        className={styles.add}
        onClick={() => onChange([...designers, { name: "", link: "" }])}
      >
        ＋ Add designer
      </button>
    </div>
  );
};

export default DesignersEditor;
